// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const PaginationLeftArrow: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    color1 = "#231f20",
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 10 18" width={width} height={height}>
            <path
                fill="currentColor"
                d="M.242 9.578a.81.81 0 0 1 0-1.156L8.58.238a.85.85 0 0 1 1.178 0 .81.81 0 0 1 0 1.156L2.008 9l7.75 7.606a.81.81 0 0 1 0 1.156.85.85 0 0 1-1.178 0z"
            />
        </svg>
    );
};

export default React.memo(PaginationLeftArrow);
